export const PROBLEM_RUN_QUERY_MOBILE = '(max-width: 768px)';

export const PROBLEM_RUN_PROBLEM_WIDTH = 800;
